/* FeltArt (Boost Online): niet automatisch naar de variantfoto scrollen op FeltArt-pagina's.
 * Het fotofilter zet de foto's van de gekozen variant al bovenaan. */
(function () {
	var original = Element.prototype.scrollIntoView;
	if (!original || window.__faNoGalleryScroll) return;
	window.__faNoGalleryScroll = true;
	Element.prototype.scrollIntoView = function () {
		if (this.classList && this.classList.contains('product-gallery-item') && /\/products\/feltart-/.test(window.location.pathname)) return;
		return original.apply(this, arguments);
	};
})();

if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.#onVariantChangeHandler.bind(this));
				this.#onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				this._buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				this._buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		disconnectedCallback(){
			if ( this._buyObserver ) {
				this._buyObserver.disconnect();
			}
		}

		#thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
						left: elm.offsetLeft - 50,
						behavior: 'smooth'
					})
				} else {
					elm.classList.remove('active');
				}
			});
		}

		#onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media?.id ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
						}
					}
				}
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}


/* ------------------------------------------------------------------
 * FeltArt gallery filter (Boost Online)
 * Toont in de productgalerij alleen de foto's van de gekozen variant.
 * De media worden gegroepeerd op de variantafbeeldingen: een groep begint
 * bij de afbeelding die aan een variant is gekoppeld en loopt door tot de
 * volgende variantafbeelding. Foto's vóór de eerste variantafbeelding zijn
 * algemeen en blijven altijd zichtbaar.
 * Alleen actief voor producttype "Felt Art" met meerdere variantafbeeldingen.
 * ------------------------------------------------------------------ */
(function () {

	if (window.__faGalleryFilter) return;
	window.__faGalleryFilter = true;

	function init(root) {

		var pv = root.querySelector('product-variants[data-main-product-variants]');
		var gallery = root.querySelector('[data-js-product-gallery]');
		if (!pv || !gallery || root._faInit) return;
		root._faInit = true;

		// oorspronkelijke volgorde van de media vastleggen
		var mediaOrder = Array.prototype.map.call(
			gallery.querySelectorAll('.product-gallery-item[data-media-id]'),
			function (el) { return el.dataset.mediaId; }
		);
		if (mediaOrder.length < 2) return;

		// thumbnails koppelen aan media-id (thumbnail i = media i)
		Array.prototype.forEach.call(root.querySelectorAll('.product-gallery__thumbnails-holder .thumbnail'), function (t) {
			var i = parseInt(t.dataset.index, 10);
			if (!isNaN(i) && mediaOrder[i]) t.dataset.mediaId = mediaOrder[i];
		});

		var url = window.location.pathname.replace(/\/$/, '') + '.js';

		fetch(url, { credentials: 'same-origin' })
			.then(function (r) { return r.ok ? r.json() : null; })
			.then(function (product) {
				if (!product || product.type !== 'Felt Art') { root.classList.add('fa-gallery-ready', 'fa-sib-ready'); return; }

				setupSiblings(root, pv, product);

				var starts = [];
				(product.variants || []).forEach(function (v) {
					if (v.featured_media && v.featured_media.id) {
						var id = String(v.featured_media.id);
						if (starts.indexOf(id) === -1) starts.push(id);
					}
				});
				if (starts.length < 2) { root.classList.add('fa-gallery-ready'); return; }

				var group = {};
				var current = null;
				mediaOrder.forEach(function (id) {
					if (starts.indexOf(id) > -1) current = id;
					group[id] = current;
				});

				var style = document.createElement('style');
				style.textContent = '#' + root.id + ' .fa-media-hidden{display:none !important}';
				document.head.appendChild(style);

				function currentVariant() {
					if (pv.currentVariant) return pv.currentVariant;
					var data = pv.querySelector('[data-js-variant-data]');
					try { return data ? JSON.parse(data.textContent) : null; } catch (e) { return null; }
				}

				function apply() {
					var scrollBefore = window.pageYOffset;
					root.firstProductGalleryIndex = 0;
					var v = currentVariant();
					var items = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery-item[data-media-id]'));
					if (!items.length) return;

					var f = v && v.featured_media ? String(v.featured_media.id) : null;
					var showAll = !f || starts.indexOf(f) === -1;
					var visibleIds = mediaOrder.filter(function (id) {
						return showAll || group[id] === null || group[id] === f;
					});
					if (!visibleIds.length) visibleIds = mediaOrder.slice();

					var byId = {};
					items.forEach(function (el) { byId[el.dataset.mediaId] = el; });
					var parent = items[0].parentNode;

					visibleIds.forEach(function (id, i) {
						var el = byId[id];
						if (!el) return;
						el.classList.remove('fa-media-hidden');
						el.removeAttribute('inert');
						el.dataset.index = i;
						parent.appendChild(el);
					});
					mediaOrder.forEach(function (id) {
						if (visibleIds.indexOf(id) > -1) return;
						var el = byId[id];
						if (!el) return;
						el.classList.add('fa-media-hidden');
						el.classList.remove('css-slide--snap', 'css-slide-active');
						el.dataset.index = -1;
						parent.appendChild(el);
					});

					var holder = root.querySelector('.product-gallery__thumbnails-holder');
					if (holder) {
						var thumbs = {};
						Array.prototype.forEach.call(holder.querySelectorAll('.thumbnail[data-media-id]'), function (t) {
							thumbs[t.dataset.mediaId] = t;
						});
						visibleIds.forEach(function (id, i) {
							var t = thumbs[id];
							if (!t) return;
							t.classList.remove('fa-media-hidden');
							t.classList.toggle('active', i === 0);
							t.dataset.index = i;
							holder.appendChild(t);
						});
						mediaOrder.forEach(function (id) {
							if (visibleIds.indexOf(id) > -1) return;
							var t = thumbs[id];
							if (!t) return;
							t.classList.add('fa-media-hidden');
							t.classList.remove('active');
							t.dataset.index = -1;
							holder.appendChild(t);
						});
						holder.scrollLeft = 0;
					}

					var slider = gallery.querySelector('css-slider');
					if (slider && slider.sliderEnabled && typeof slider.resetSlider === 'function') {
						slider.items = slider.querySelectorAll('.product-gallery-item:not(.fa-media-hidden)');
						slider.resetSlider();
					}

					// voorkom dat de pagina verspringt door het herschikken van de foto's
					if (Math.abs(window.pageYOffset - scrollBefore) > 2) {
						window.scrollTo(0, scrollBefore);
					}
					root.classList.add('fa-gallery-ready');
				}

				pv.addEventListener('VARIANT_CHANGE', function () { apply(); });
				var slider = gallery.querySelector('css-slider');
				if (slider) {
					slider.addEventListener('ready', function () { setTimeout(apply, 0); });
					slider.addEventListener('destroy', function () { setTimeout(apply, 0); });
				}
				apply();
			})
			.catch(function () { root.classList.add('fa-gallery-ready', 'fa-sib-ready'); });
	}

	/* Maatkeuze ("Choose your size"): toon per maat de foto in de gekozen kleur
	 * en laat de link direct naar dezelfde kleur in die maat gaan. */
	function setupSiblings(root, pv, product) {

		var links = Array.prototype.slice.call(root.querySelectorAll('.product-variants--thumbnails a.product-variant__item[href]'));
		if (!links.length) { root.classList.add('fa-sib-ready'); return; }

		function colourIndex(p) {
			var idx = 0;
			((p && p.options) || []).forEach(function (o, i) {
				var name = (typeof o === 'string' ? o : (o && o.name) || '');
				if (/colou?r|kleur|farbe|couleur/i.test(name)) idx = i;
			});
			return idx;
		}
		var ci = colourIndex(product);

		function imgUrl(src, w) {
			if (!src) return null;
			if (src.indexOf('//') === 0) src = 'https:' + src;
			return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
		}

		var siblings = links.map(function (a) {
			var base = a.getAttribute('href').split('?')[0].split('#')[0];
			return { a: a, base: base, data: null };
		});

		function currentVariant() {
			if (pv.currentVariant) return pv.currentVariant;
			var data = pv.querySelector('[data-js-variant-data]');
			try { return data ? JSON.parse(data.textContent) : null; } catch (e) { return null; }
		}

		function update() {
			var v = currentVariant();
			if (!v || !v.options) return;
			var colour = v.options[ci];
			siblings.forEach(function (s) {
				if (!s.data) return;
				var sci = colourIndex(s.data);
				var match = (s.data.variants || []).filter(function (sv) { return sv.options && sv.options[sci] === colour; })[0];
				if (!match) return;
				s.a.setAttribute('href', s.base + '?variant=' + match.id);
				var src = match.featured_image && match.featured_image.src;
				var img = s.a.querySelector('img');
				if (src && img) {
					// alleen vervangen als het een andere foto is (voorkomt flikkeren)
					var fileOf = function (u) { return String(u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); };
					if (fileOf(img.currentSrc || img.getAttribute('src')) === fileOf(src)) return;
					img.removeAttribute('data-srcset');
					img.setAttribute('srcset', imgUrl(src, 120) + ' 120w, ' + imgUrl(src, 240) + ' 240w');
					img.setAttribute('src', imgUrl(src, 240));
				}
			});
		}

		Promise.all(siblings.map(function (s) {
			return fetch(s.base + '.js', { credentials: 'same-origin' })
				.then(function (r) { return r.ok ? r.json() : null; })
				.then(function (d) { s.data = d; })
				.catch(function () {});
		})).then(function () {
			pv.addEventListener('VARIANT_CHANGE', update);
			update();
			root.classList.add('fa-sib-ready');
		});
	}

	function run() {
		document.querySelectorAll('product-page[data-js-product-component]').forEach(function (root) {
			init(root);
			// vangnet: altijd tonen, ook als het filter niet van toepassing is of iets misgaat
			setTimeout(function () { root.classList.add('fa-gallery-ready', 'fa-sib-ready'); }, 1500);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}

})();

/* FeltArt (Boost Online): tekst "Set of 2 panels." laten meebewegen met de gekozen variant (2, 4 of 6 panelen). */
(function () {
	var RE = /^\s*(Set of|Set van)\s+\d+\s+(panels|panelen)(\.?)\s*$/i;
	function run() {
		document.querySelectorAll('product-page[data-js-product-component]').forEach(function (root) {
			var pv = root.querySelector('product-variants[data-main-product-variants]');
			if (!pv) return;
			var targets = Array.prototype.filter.call(root.querySelectorAll('p, span, div'), function (el) {
				return el.children.length === 0 && RE.test(el.textContent);
			});
			if (!targets.length) return;
			function update() {
				var v = pv.currentVariant;
				if (!v) {
					var d = pv.querySelector('[data-js-variant-data]');
					try { v = d ? JSON.parse(d.textContent) : null; } catch (e) { v = null; }
				}
				if (!v || !v.options) return;
				var n = null;
				v.options.forEach(function (o) {
					var m = String(o).match(/(\d+)\s*(panels|panelen|pieces|stuks)/i);
					if (m) n = m[1];
				});
				if (!n) n = '2';
				targets.forEach(function (el) {
					el.textContent = el.textContent.replace(/\d+/, n);
				});
			}
			pv.addEventListener('VARIANT_CHANGE', update);
			update();
		});
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
